(function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .controller( 'ShipmentBoePreviewController', ShipmentBoePreviewController );

    ShipmentBoePreviewController.$inject = [ 'entity', '$uibModalInstance', 'PDFExportService', 'ToastrService' ];

    function ShipmentBoePreviewController( entity, $uibModalInstance, PDFExportService, ToastrService ) {

        var vm = this;

        vm.shipment = entity;

        vm.close = close;
        vm.download = download;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function download() {
            PDFExportService.downloadShipmentBoePDF( vm.shipment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/pdf'});
                saveAs(file, "Bill Of Exchange - " + vm.shipment.shipmentSiNum + '.pdf');
            }, function(error) {
                ToastrService.error( "Something went wrong", "Error!" );
            });
        }
    }
})();
